module.exports = __webpack_public_path__ + "static/Trans-8-Clean-6a21f376f910e8a88fcb0582aa84e946.svg";